import QuotePart from "/src/components/quote/QuotePart";
import ChooseCompany from "../../../features/administration/company/components/ChooseCompany/ChooseCompany";

function ChooseCompanyPage() {
    return(
        <div className="page default">
            <ChooseCompany></ChooseCompany>
            <div className="quote-part">
                <QuotePart fontSize="50" fontColor="white" />
            </div>
        </div>
    )
}

export default ChooseCompanyPage;